export type ToastType = 'success' | 'error' | 'warning' | 'info';

type ToastPayload = {
  message: string;
  title?: string;
  type?: ToastType;
  duration?: number;
};

const toastBus = new EventTarget();

export const emitToast = (message: string, type: ToastType = 'info', duration = 4000, title?: string) => {
  toastBus.dispatchEvent(
    new CustomEvent<ToastPayload>('toast', {
      detail: { message, type, duration, title },
    })
  );
};

export const subscribeToToast = (callback: (payload: Required<ToastPayload>) => void) => {
  const handler = (event: Event) => {
    const detail = (event as CustomEvent<ToastPayload>).detail;
    if (!detail?.message) {
      return;
    }
    callback({
      message: detail.message,
      title: detail.title || '',
      type: detail.type || 'info',
      duration: detail.duration || 4000,
    });
  };

  toastBus.addEventListener('toast', handler);
  return () => toastBus.removeEventListener('toast', handler);
};
